module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no":"@:labels.no","question":"Are you sure you want to delete this element ?","title":"Delete Element","yes":"@:labels.yes"},"fr":{"no":"@:labels.no","question":"Êtes-vous certain de vouloir supprimer cet élément ?","title":"Supprimer l\u0027élément","yes":"@:labels.yes"}}')
  delete Component.options._Ctor
}
